import { Maybe, noop, v2_ProductDetail } from '@crocodille/common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMedia } from '../../../hooks/use-media';
import Modal from '../../elements/modal/modal';
import HorizontalListSelect from '../../horizontal-list-select/horizontal-list-select';
import RadioSelect from '../../radio-select/radio-select';

import styles from './menu-incentive.module.scss';

export interface MenuIncentiveProps {
  readonly incentive?: Maybe<v2_ProductDetail['configuration'][number]>;
  readonly incentiveValue?: string | null;
  readonly showPrices: boolean;
  onChoice?(code: string | null): void;
  onClose?(): void;
  readonly open?: boolean;
}

const MenuIncentive: React.FC<React.PropsWithChildren<MenuIncentiveProps>> = ({
  incentive,
  incentiveValue,
  showPrices,
  onChoice = noop,
  onClose = noop,
  open = false,
}) => {
  const { t } = useTranslation();

  const isHorizontalListMenu = useMedia(
    'menu-configuration-as-horizontal-list',
    false,
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeOnOutsideClick={true}
      showCloseButton={false}
      width="auto"
      title={t('product.menu_incentive')}
    >
      <div className={styles.selection}>
        {isHorizontalListMenu ? (
          <HorizontalListSelect
            value={incentiveValue}
            onChange={onChoice}
            className={styles.selectGroup}
          >
            {(incentive?.options ?? []).map(
              ({ name, itemCode, image, unitPrice }) => {
                return (
                  <HorizontalListSelect.Option
                    key={itemCode}
                    value={itemCode}
                    label={name}
                    price={showPrices ? unitPrice ?? undefined : undefined}
                    priceAdjustment
                    image={image}
                  />
                );
              },
            )}
          </HorizontalListSelect>
        ) : (
          <RadioSelect
            value={incentiveValue}
            onChange={onChoice}
            withBackground
          >
            {(incentive?.options ?? []).map(
              ({ name, itemCode, image, unitPrice }) => {
                return (
                  <RadioSelect.Option
                    key={itemCode}
                    value={itemCode}
                    label={name}
                    price={showPrices ? unitPrice ?? undefined : undefined}
                    priceAdjustment
                    image={image}
                    largeImage
                  />
                );
              },
            )}
          </RadioSelect>
        )}
      </div>
    </Modal>
  );
};

export default MenuIncentive;
